<div id="rightSideBar">
  <div class="overLayDiv active" *ngIf="isGradePanelOpen"></div>
  <div class="rightSidePanel d-flex flex-column w-85pc" *ngIf="isGradePanelOpen" >
    <header class="panel-header">
      <div class="viewDemo title-and-video">
          <h2>{{ 'label_Step' | translate}} 1 - {{ "grade_wizard_text1" | translate }}</h2>
          <app-video-icon [VideoUrl]="videoLink | safeUrl"></app-video-icon>
      </div>            
      <div class="panel-left-btn">
          <button type="button" class="btn eod-btn-primary mr-2" (click)="fnShowSaveGradePanel('add', null);">
            {{ 'grade_add' | translate }}
          </button>
          <button type="button" class="btn eod-btn-outline-warning" (click)="closePanel();">
            {{ 'back_to_wizard' | translate }}
          </button>
      </div>
    </header>
    <div class="block mt-2 heightCalc-5">
      <div class=" heightCalc-10">
        <app-grid [columns]="gridColumnDefs" [data]="gridData" [gridConfigItems]="gridConfigItems"
        [gridFilterItems]="gridFilterItems" (filterChanged)="fnGridFilterChanged($event)"
        (onCellClick)="fnOnGridCellClick($event)" (onCheckAll)="fnOnGridCheckAll($event)">
      </app-grid>
      </div>
    </div>
  </div>
</div>

<app-action-panel [(model)]="actionPanelModel" [config]="actionPanelConfig"
  (onSubmitPanel)="onActionPanelSubmit($event)" [hideActionButtons]="hideActionButtons">
</app-action-panel>

<app-claimant-details-component *ngIf="showClaimantPanel" [lstClaimants]="lstClaimants" [panelHeader]="panelHeader"
  (callbackEvent)="fnPanelReceiver()"></app-claimant-details-component>


<div id="rightSideBar">

  <div class="rightSidePanel d-flex flex-column" id="bulkActionDiv" *ngIf="bulkActionDiv==true">
    <header class="panel-header">
      <div class="viewDemo title-and-video">
          <h2>{{ 'bulk_actions_selected' | translate }} {{selectedItemsList.length}}</h2>
      </div>            
      <div class="panel-left-btn">
          <button type="button" class="btn eod-btn-outline-warning" (click)="onClosePanel()" >
            {{ 'label_close' | translate }}
          </button>
      </div>
    </header>
    <div class="block mt-2">
      <div class="col-md-12 col-sm-12 no-padding-right-left ">
        <ul class="bulkList margin-bottom-0">
          <li *ngIf="gridFilterStatus == 1" [ngClass]="{'disabled':disableDeactiveButton==true}" class="margin-bottom-0"
            (click)="bulkDeactivateGradeConfirm();"><span>
              <app-deactivate-minus-icon class="">
              </app-deactivate-minus-icon>{{ 'grade_deactivate' | translate }}
            </span></li>
          <li *ngIf="gridFilterStatus == 2" [ngClass]="{'disabled':disableDeactiveButton==true}" class="margin-bottom-0"
            (click)="bulkDeactivateGradeConfirm();"><span>
              <app-activate-plus-icon class="">
              </app-activate-plus-icon>{{ 'grade_activate' | translate }}
            </span></li>
        </ul>
      </div>
    </div>
  </div>

</div>

<marketing-popup *ngIf="showAssignCategorieToGradePopup" [data]="assigncategoriestogradePopupModel"
  (closePanel)="closeAssigncategoriestogradePopup()">
</marketing-popup>

<app-alert-panel [data]="alertPanelModelForBulk" (callbackEvent)="alertPanelReceiverForBulk($event)"></app-alert-panel>
<app-alert-panel [data]="alertPanelModelForDeactivatingAllGrades" (callbackEvent)="alertPanelReceiverForDeactivatingAllGrades($event)"></app-alert-panel>

<grade-assign-category-list-panel *ngIf="showAssignCategoriesToGradeListPanel" [(inputModel)]="assignCategoriesToGradeListPanelInputModel"
(closePanelEvent)="fnCloseAssignCategoriesToGradeListPanel($event)"></grade-assign-category-list-panel>
